import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesDetailSection from '../components/ServicesDetailSection';
import QuoteFormSection from '../components/QuoteFormSection';
import FeaturedProjectsSection from '../components/FeaturedProjectsSection';
import ProjectGallerySection from '../components/ProjectGallerySection';
import TestimonialsSection from '../components/TestimonialsSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import CallToActionSection from '../components/CallToActionSection';
import Footer from '../components/Footer';
export function HomePage() {
  return <>
      <div id="hero" data-id="element-547">
        <HeroSection data-id="element-548" />
      </div>
      <div id="about" data-id="element-549">
        <AboutSection data-id="element-550" />
      </div>
      <div id="services" data-id="element-551">
        <ServicesDetailSection data-id="element-552" />
      </div>
      <div id="work" data-id="element-553">
        <ProjectGallerySection data-id="element-554" />
      </div>
      <div id="contact" data-id="element-555">
        <QuoteFormSection data-id="element-556" />
      </div>
      <FeaturedProjectsSection data-id="element-557" />
      <div id="testimonials" data-id="element-558">
        <TestimonialsSection data-id="element-559" />
      </div>
      <WhyChooseUsSection data-id="element-560" />
      <CallToActionSection data-id="element-561" />
      <Footer data-id="element-562" />
    </>;
}